import { Component, Input, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-purchase-order-summary',
    templateUrl: './purchase-order-summary.component.html',
    styleUrls: ['./purchase-order-summary.component.scss'],
    standalone: false
})
export class PurchaseOrderSummaryComponent implements OnInit {
  @Input() calculation: any = '';
  @Input() title:string='Vendor P.O Summary'

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges) {
    if(changes){
      this.calculation=changes['calculation']?.currentValue
    }
    console.log('ProposalCostWidgetComponent', changes);
    console.log('statics calculation',this.calculation);
  }

}
